import React, { useContext, useEffect, useState } from "react";
import { MainContext } from "../App";
import { isTabletEmbed, postToParent } from "../embed";
import HamburgerIcon from "../icons/HamburgerIcon";
import SearchIcon from "../icons/SearchIcon";
import CloseIcon from "../icons/CloseIcon";

function Tables() {
	const {
		shop,
		setShop,
		settings,
		setPopupVisible,
		initCart,
		setFlow,
		setTable,
		setUser,
		user,
		tables,
		rooms,
		table,
		setTempTable,
		setTableEditPopup,
		ordersDisabled,
		setMenuVisible,
	} = useContext(MainContext);
	const [room, setRoom] = useState(false);
	const [search, setSearch] = useState("");
	const [now, setNow] = useState(Date.now());

	useEffect(() => {
		const filtered = rooms.filter((r) => r.shop_id == shop.id);
		if (filtered.length > 0) setRoom(filtered[0]);
	}, []);

	useEffect(() => {
		if (shop) {
			const filtered = rooms.filter((r) => r.shop_id == shop.id);
			if (filtered.length > 0) setRoom(filtered[0]);
			else setRoom(false);
		} else setRoom(false);
	}, [shop]);

	useEffect(() => {
		console.log("room set to", room);
	}, [room]);

	useEffect(() => {
		const intervalId = window.setInterval(() => {
			setNow(Date.now());
		}, 30000);
		return () => window.clearInterval(intervalId);
	}, []);

	const handleClick = async (table) => {
		console.log("handleClick");
		console.log("covers", table.covers);
		setTempTable(table);
		if (table.status == 0) {
			setPopupVisible("covers");
		} else if (table.status == 1 && !ordersDisabled) {
			initCart();
			setFlow(1);
			setTable(table);
		} else {
			setTableEditPopup(true);
		}
	};

	const getClassName = (status) => {
		if (status == 0) return "";
		if (status == 1) return "bg-success";
		if (status == 2) return "bg-warning";
	};

	const getPin = (table) => {
		if (
			settings.selfordering.pin_mode == "generated" ||
			settings.selfordering.pin_mode == "fixed"
		)
			return table ? table.pin : null;
		if (settings.selfordering.pin_mode == "shop") return shop.selfordering_pin;
		if (settings.selfordering.pin_mode == "disabled") return false;
	};

	const parseServerDateTime = (value) => {
		if (!value) return null;
		if (value instanceof Date) return value;
		if (typeof value !== "string") return null;
		const normalized = value.trim().replace(" ", "T");
		const parsed = new Date(normalized);
		if (!Number.isNaN(parsed.getTime())) return parsed;
		const parts = value.match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})(?::(\d{2}))?$/);
		if (!parts) return null;
		const [, year, month, day, hours, minutes, seconds = "0"] = parts;
		return new Date(Number(year), Number(month) - 1, Number(day), Number(hours), Number(minutes), Number(seconds));
	};

	const getLastOrderMeta = (table) => {
		const lastOrderAt = table?.last_order_date;
		if (!lastOrderAt) return null;
		const parsedLastOrderAt = parseServerDateTime(lastOrderAt);
		if (!parsedLastOrderAt) return null;
		const minutes = Math.max(0, Math.floor((now - parsedLastOrderAt.getTime()) / 60000));
		let label;
		if (minutes < 60) {
			label = minutes + "' fa";
		} else if (minutes < 1440) {
			label = Math.floor(minutes / 60) + "h fa";
		} else {
			label = Math.floor(minutes / 1440) + " giorni fa";
		}
		if (minutes <= 5) return { label, className: "is-fresh" };
		if (minutes <= 15) return { label, className: "is-medium" };
		return { label, className: "is-late" };
	};

	const normalizedSearch = search.trim().toLowerCase();
	const filteredTables = tables
		? tables.filter((t) => {
				if (!normalizedSearch) return room && t.room_id == room.id;
				const tableName = String(t.name || "").toLowerCase();
				const roomName = String(
					t.room?.name ||
						rooms.find((r) => parseInt(r.id) === parseInt(t.room_id))?.name ||
						""
				).toLowerCase();
				return (
					tableName.includes(normalizedSearch) ||
					roomName.includes(normalizedSearch)
				);
			})
		: [];

	return (
		<div className="popup full tables-screen">
			<div className="container">
				<header>
					<div className="buttons-group">
						<button
							onClick={() => setMenuVisible(true)}
							className="btn btn-tertiary btn-square"
							style={isTabletEmbed ? { display: "none" } : undefined}
						>
							<HamburgerIcon />
						</button>
						{table && (
							<button
								className="btn btn-tertiary btn-square"
								onClick={() => setPopupVisible(false)}
							>
								<CloseIcon />
							</button>
						)}
						<div>Tavoli</div>
						{isTabletEmbed && (
							<div className="tablet-mode-pill">
								<span className="tablet-mode-dot"></span>
								Modalità tablet · Operatore: <strong>{user?.name}</strong>
							</div>
						)}
					</div>
					<div className="header-right-actions">
					<div className="header-src">
						<input
							type="text"
							placeholder="Cerca tavolo"
							value={search}
							onChange={(e) => setSearch(e.target.value)}
						/>
						{search ? (
							<button className="clear-btn" onClick={() => setSearch("")}><CloseIcon /></button>
						) : (
							<div className="search-icon"><SearchIcon /></div>
						)}
					</div>
				{isTabletEmbed && (
						<button className="btn-embed-exit" onClick={() => postToParent({ type: "exit" })}>
							Esci
						</button>
					)}
					</div>
				</header>
				<div className="horizzontal-menu">
					<div className="scroll-content">
						{rooms &&
							rooms
								.filter((r) => r.shop_id == shop.id)
								.map((r, i) => (
									<button
										key={i}
										className={
											parseInt(r.id) == parseInt(room.id)
												? "btn btn-primary"
												: "btn btn-tertiary"
										}
										onClick={() => setRoom(r)}
									>
										{r.name}
									</button>
								))}
					</div>
				</div>
				<div className="content">
					<div className="tables-container">
						{filteredTables.length > 0 ? (
							<>
								{normalizedSearch && (
									<div className="category-title search-results-title tables-search-results-title">
										Risultati della ricerca
									</div>
								)}
								{filteredTables.map((t, i) => {
									const lastOrderMeta = getLastOrderMeta(t);
									return (
										<button
											onClick={() => handleClick(t)}
											key={i}
											className={"table-card " + (getClassName(t.status) || "")}
										>
											<div className="header">
												<div>
													<b>{t.name}</b>
												</div>
												{t.status == 1 && (
													<div className="duration">{t.duration}</div>
												)}
												{t.status == 2 && (
													<div className="duration pending-bill">Attesa conto</div>
												)}
											</div>
											<div className="info extrasmall">
												<div className="info-column">
													<div className="info-line">
														<span className="info-label-inline">Listino:</span>{" "}
														<span className="info-value-inline">{t.list_id ? t.list?.name || "Base" : "Base"}</span>
													</div>
													<div className="info-line">
														<span className="info-label-inline">Cameriere:</span>{" "}
														<span className="info-value-inline">{t.user?.name || "-"}</span>
													</div>
													<div className="info-line">
														<span className="info-label-inline">Pin:</span>{" "}
														<span className="info-value-inline text-bold">
															{t.status != 0 && getPin(t) ? getPin(t) : "-"}
														</span>
													</div>
												</div>
												<div className="info-column">
													<div className="info-line">
														<span className="info-label-inline">Ordini:</span>{" "}
														<span className="info-value-inline">{t.orders_count}</span>
													</div>
													<div className="info-line">
														<span className="info-label-inline">Portata:</span>{" "}
														<span className="info-value-inline">
															{(settings.orders?.enable_flow ?? settings.waiter_app?.enable_flow) == 1
																? (t.flow ?? "-")
																: "-"}
														</span>
													</div>
													<div className="info-line">
														<span className="info-label-inline">Coperti:</span>{" "}
														<span className="info-value-inline">{t.covers}</span>
													</div>
												</div>
												<div className="info-column info-column-total">
													{lastOrderMeta && (
														<div className={"table-order-age " + lastOrderMeta.className}>
															<span>Ultimo ordine {lastOrderMeta.label}</span>
															<span className="table-order-age-dot"></span>
														</div>
													)}
												</div>
											</div>
										</button>
									);
								})}
							</>
						) : (
							<div className="full-centered">
								<div>
									Nessun tavolo trovato
									<br />
									<button
										style={isTabletEmbed ? { display: "none" } : undefined}
										onClick={() => {
											localStorage.removeItem("waiter-user");
											setTable(false);
											setShop(false);
											setUser(false);
										}}
									>
										Torna al login
									</button>
								</div>
							</div>
						)}
					</div>
				</div>
			</div>
		</div>
	);
}

export default Tables;
